module.exports = __webpack_public_path__ + "img/4.1b4f762a.jpg";